<template>
  <div class="citiesmap-cont">
    <div ref="result"/>
    <div class="cm-settings-cont">
      <h1>Best Turkish Restaurants</h1>
      <h2>Find a Restaurant Near You</h2>
      <p>Look up for the closest Turkish Restaurant near your location!</p>
      <div class="cm-option">
        <div class="cm-option-item">
          <city-map-places :location="deliverto" :found="placesFound"></city-map-places>
        </div>
        <div class="cm-option-item">
          <label for="max-distance">Enter Max Distance (Miles): </label><input id="max-distance" :disabled="deliverToMe" type="number" value="1" min="1" max="30" v-model="radius">
        </div>
        <div class="cm-option-item">
          <label for="delivers-to-me">Delivers to me: </label><input id="delivers-to-me" type="checkbox" v-model="deliverToMe">
        </div>
        <div class="cm-option-item cm-buttons">
          <div class="cm-option-button" @click="search">Find a Restaurant</div>
          <div class="cm-option-button" @click="reset">Reset</div>
        </div>
      </div>
    </div>
    <restaurants-on-map-component :coordinate="coordinate_set" :radius="radius_set" :deliver-to-me="deliverToMe" />
  </div>
</template>

<script>
import CityMapPlaces from '../../../components/google-places/CityMapPlaces'
import RestaurantsOnMapComponent from './components/RestaurantsOnMapComponent'
export default {
  name: 'CitiesMap',
  props: {},
  components: {
    RestaurantsOnMapComponent,
    CityMapPlaces
  },
  data () {
    return {
      deliverto: '',
      coordinate: {
        lat: 40.745349832837114,
        lng: -73.98667176088286
      },
      coordinate_set: {
        lat: 40.745349832837114,
        lng: -73.98667176088286
      },
      radius_set: '2',
      deliverToMe: false,
      radius: '2',
      placeService: null
    }
  },
  watch: {
    deliverToMe () {
      if (!this.deliverToMe) {
        this.reset()
      }
    }
  },
  methods: {
    search () {
      this.coordinate_set = this.coordinate
      console.log(this.coordinate)
      this.radius_set = this.radius
    },
    reset () {
      this.radius = '2'
      this.radius_set = '2'
      this.coordinate = {
        lat: 40.676453,
        lng: -73.943940
      }
      this.coordinate_set = {
        lat: 40.676453,
        lng: -73.943940
      }
    },
    getPlaceDetails (place_id, callback) {

      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        callback(PlaceResult)
      })
    },
    placesFound (value, deliver_to) {
      this.deliverto = deliver_to
      const self = this
      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        self.coordinate = {
          lat: PlaceResult.geometry.location.lat(),
          lng: PlaceResult.geometry.location.lng()
        }
      })
    }
  },
  computed: {},
  mounted () {
    this.placeService = new window.google.maps.places.PlacesService(this.$refs.result)
    this.search()
  }
}
</script>
<style lang="scss">
.router-view{
  max-width: 100%;
  .content-area__content{
    max-width:100%;
    padding:0;
  }
}
.cm-settings-cont {
  width:100%;
  max-width: 1200px;
  margin:0 auto;
  margin-bottom:20px;
  h1{
    font-weight:900;
    span{
      text-transform: uppercase;
      margin-right:8px;
    }
  }
  p{
    font-weight:bold;
    margin-top:20px;
  }
}
.cm-option{
  display:flex;
  margin-top:10px;
  gap:20px;
}
.cm-option-item{
  display: flex;
  flex-basis:max-content;
  align-items:center;
  width:25%;
  gap:10px;
  label{
    margin:0;
  }
  &.cm-buttons{
    justify-content: flex-start;
    gap:10px;
  }
  input[type="text"]{
    width:100%;
    padding:10px;
    border:1px solid #ccc;
    border-radius: 7px;
    width:250px;
  }
  input[type="number"]{
    width:65px;
  padding: 10px;
  border:1px solid #ccc;
  border-radius: 7px;
  }
}
.cm-option-button {
  background-color:#0070eb;
  border-radius: 5px;
  color:#fff;
  font-weight: 700;
  padding:8px 20px;
  cursor:pointer;
  &:last-child{
    background-color:#000
  }
}
@media (max-width:768px){
  #map-container{
    height: 300px;
  }
  .cm-settings-cont{
    padding:20px;
    h1{
      font-size:39px;
    span{
      display:block;
    }
  }
  p {
    font-size:20px;
    margin:0px;
  }
}
  .cm-option{
    flex-direction:column;
    gap:10px;
    width: 100%;
    .cm-option-item{
      width:100%;
      padding:0;
      display:flex;
      justify-content: space-between;
      flex-basis:50%;
      align-items:center;
      input[type="text"]{
        width:100%;
      }
      &.cm-buttons{
        margin-top:15px;
      }
      label{
        font-weight: bold;
        font-size: 18px;
        margin:0;
      }
      #max-distance{
        text-align: center;
        font-weight: 900;
        font-size:18px;
        padding:3px 10px;
      }
      #delivers-to-me{
width:30px;
height: 30px;
      }
    }
  }
  .cm-option-item.cm-buttons{
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
</style>
